// extracted by mini-css-extract-plugin
module.exports =  {"default":"_32bbee5fda--default--UNCuI","light":"_32bbee5fda--light--fV8h9","outline":"_32bbee5fda--outline--P5mEa"};